module.exports = __webpack_public_path__ + "e2873b9ffcfe04aa6b7388a1db675325.svg";